export const FacebookUrl = "https://www.facebook.com/postiesevent";
export const InstagramUrl = "https://www.instagram.com/scmp_posties";
export const YoutubeUrl = "https://www.youtube.com/@postiesevent9134";
